import styled from "styled-components";
import { h1, h2, h3 } from "../../styles/typography";

const H1Title = styled(h1)<{ backgroundColor: string }>`
  color: ${(props) =>
    props.backgroundColor === "white"
      ? ({ theme }) => theme.colors.primary
      : ({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  padding-top: 10px;
  width: fit-content;
`;

const H2Title = styled(h2)<{ backgroundColor: string }>`
  color: ${(props) =>
    props.backgroundColor === "white"
      ? ({ theme }) => theme.colors.primary
      : ({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  padding-top: 10px;
  width: fit-content;
`;

const H3Title = styled(h3)<{ backgroundColor: string }>`
  color: ${(props) =>
    props.backgroundColor === "white"
      ? ({ theme }) => theme.colors.primary
      : ({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  padding-top: 10px;
  width: fit-content;
`;

const AccentTitle = styled.span`
  color: ${({ theme }) => theme.textColors.tertiary};
`;

const Line = styled.div<{ backgroundColor: string }>`
  border-bottom: 2px solid
    ${(props) =>
      props.backgroundColor === "white"
        ? ({ theme }) => theme.colors.primary
        : ({ theme }) => theme.textColors.secondary};
  width: 100%;
  min-width: fit-content;
  height: 0px;
  margin: 30px 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 10px 0 10px 0;
  }
`;

const S = {
  H1Title,
  H2Title,
  H3Title,
  AccentTitle,
  Line,
};

export default S;
